<div class="min-h-screen w-full mx-auto px-4 flex flex-col" *ngIf="config">

  <div class="flex flex-row justify-between" id="logo-wrapper">
    <img [src]="getLogoUrl()" alt="Logo" class="w-64 py-6 px-3 logo-image">
    <content-block [slug]="'gallery-header'" id="gallery-header"></content-block>
  </div>

  <div class="grid grid-cols-6 grid-flow-row gap-4">
    <ng-container *ngFor="let job of jobs">
      <div class="relative w-full" *ngIf="job && job.status == 'completed' && hasAtLeastOneOutputAsset(job)">
        <image-slider [images]="filter(job.assets)" [autoPlaySpeed]="job.interval || 3000" [aspectClass]="'1080/1608'"></image-slider>
      </div>
    </ng-container>
  </div>

  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper"></content-block>
</div>

